import { v4 as uuid } from "uuid";
import { IConclusionService, IConclConstrWeblauncherSettings, IConclusionServiceData } from "./ITypes.ts";
import { ErrorSessionNotFound, ErrorRequestConstructor } from "./Errors.ts";
export default class ConclusionServiceWebLauncher implements IConclusionService {
    session_id: string = "";
    private intervalID: ReturnType<typeof setInterval> | undefined;
    private webLauncherUrl: string = "";
    private apiURL: string = "";

    public async openConstructor(reportData: IConclusionServiceData) {
        this.session_id = uuid();
        const dataStr = window.btoa(JSON.stringify(reportData));

        let url = new URL(this.webLauncherUrl + "StdEcgReportStart");
        url.searchParams.append("sessionId", this.session_id);
        url.searchParams.append("data", dataStr);

        this.reqCustomScheme(url);

        return this.session_id;
    }
    private reqCustomScheme(url: URL) {
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url.href;
        a.click();
        a.remove();
    }

    public SetSettings(setts: IConclConstrWeblauncherSettings) {
        if (!setts) return;
        let { webLauncherUrl, reportConstructorAPIurl } = setts;
        this.webLauncherUrl = webLauncherUrl;
        this.apiURL = reportConstructorAPIurl;
    }

    public async StartWaitAnswer() {
        return new Promise<string>((resolve, reject) => {
            // Clear previous interval
            clearInterval(this.intervalID as NodeJS.Timeout);
            let waiting = false;
            //await this.reqStatus();

            this.intervalID = setInterval(async () => {
                try {
                    if (waiting) {
                        return;
                    }
                    waiting = true;
                    let res = await this.reqStatus();
                    if (res) {
                        this.StopWaitAnswer();
                        // Remove unnecessary quotes from start and end
                        res = res.slice(1, -1);
                        resolve(res);
                    }
                } catch (err) {
                    this.StopWaitAnswer();
                    reject(err);
                } finally {
                    waiting = false;
                }
            }, 1000);
        });
    }

    public StopWaitAnswer() {
        clearInterval(this.intervalID as NodeJS.Timeout);
    }

    private async reqStatus() {
        let url = new URL(this.apiURL + "StdEcgReportStatus");
        url.searchParams.append("sessionId", this.session_id);
        const res = await fetch(url);
        // Ok
        if (res.status === 200) {
            return await res.text();
        }
        //this.StopWaitAnswer();

        // Wrong id, session is not found
        if (res.status === 404) throw new ErrorSessionNotFound();

        // SessionID is absent in request
        if (res.status === 400) throw new ErrorRequestConstructor();

        //  throw new Error();
    }
}
